import React, { useEffect, useState, useCallback } from "react";
import FinanceView from "./FinanceView";
import { getFinanceSummary, getTransactions } from "../../../api/financeApi";
import { Spinner, ErrorState } from "../../../components/panel/PanelUI";

const LIMIT = 8;

export default function FinanceTab() {
  const [summary, setSummary] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadData = useCallback((targetPage) => {
    setLoading(true);
    setError("");
    Promise.all([
      getFinanceSummary(),
      getTransactions({ page: targetPage, limit: LIMIT }),
    ])
      .then(([summaryData, txData]) => {
        setSummary(summaryData);
        setTransactions(txData?.items || txData || []);
        setTotalPages(txData?.totalPages || 1);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    loadData(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  if (loading) return <Spinner label="در حال دریافت اطلاعات مالی..." />;
  if (error) return <ErrorState message={error} onRetry={() => loadData(page)} />;

  return (
    <FinanceView
      summary={summary}
      transactions={transactions}
      page={page}
      totalPages={totalPages}
      onPageChange={setPage}
    />
  );
}
